import React from 'react'
import PropTypes from 'prop-types'
import NachweisFileIcon from '#components/svg/icons/NachweisFileIcon'
import IconButton from '#components/a/IconButton'

function Attachment(props) {
  const {isReadOnly, filename, onDelete} = props
  return (
    <div className="nachweisdetail__attachment">
      <NachweisFileIcon />
      <span>{filename}</span>
      {!isReadOnly && <IconButton event={onDelete} icon="delete" />}
    </div>
  )
}
Attachment.propTypes = {
  filename: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  isReadOnly: PropTypes.bool,
}

export default Attachment
